import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {getIntegrationModuleInfo} from "@/pages/integrations/integrations.types.ts";
import {TestIntegrationForm} from "@/pages/integrations/test/TestIntegrationForm.tsx";

interface TestIntegrationModalProps {
  show: boolean;
  hide: () => void;
  integration: IntegrationFormData;
  onEdit: () => void;
}

export const TestIntegrationModal = ({show, hide, integration, onEdit}: TestIntegrationModalProps) => {
  const {user} = useCurrentUserContext();
  const moduleInfo = getIntegrationModuleInfo(integration.module);
  return (
    <UpErrorBoundary>
      <FormModal
        title={
          <div className={"d-flex align-items-center"}>
            Test Integration:
            {moduleInfo?.logo && (
              <img
                src={moduleInfo.logo}
                alt={moduleInfo.label}
                height={22}
                width={22}
                className={"pulse-border-radius-xl ms-2"}
              />
            )}
            <span className={"ms-2"}>{integration.name}</span>
          </div>
        }
        onCancel={hide}
        show={show}
        size="lg"
        hasSubmitButton={false}
        cancelBtnText="Close"
        leftAction={
          user?.has_write_access ? (
            <Button variant="secondary" onClick={onEdit}>
              Edit Integration
            </Button>
          ) : undefined
        }
      >
        <TestIntegrationForm integration={integration} />
      </FormModal>
    </UpErrorBoundary>
  );
};
